export default __webpack_public_path__ + "static/media/Warmup Track Athletics3.258a64fd.jpg";